//Header animation init
function headerscroll() {
    var docElem = document.documentElement,
        didScroll = false,
        changeHeaderOn = 35;

    function init() {
        window.addEventListener('scroll', function (event) {
            if (!didScroll) {
                didScroll = true;
                setTimeout(scrollPage, 250);
            }
        }, false);
    }

    function scrollPage() {
        var sy = scrollY();
        if (sy >= changeHeaderOn) {
            $('.cbp-af-header').addClass('cbp-af-header-shrink');
        }
        else {
            $('.cbp-af-header').removeClass('cbp-af-header-shrink');
        }
        didScroll = false;
    }

    function scrollY() {
        return window.pageYOffset || docElem.scrollTop;
    }

    init();
}

//Slick Init
$('.slick').slick({
    autoplay:true,
    autoplaySpeed: 10000,
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    fade: true,
    cssEase: 'linear',
    swipe: false,
    swipeToSlide: false,
    touchMove: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    draggable: false

});
$('.scents').slick({
    infinite: true,
    autoplay:true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    dots: false,
    arrows: false,
    speed: 1000,
    cssEase: 'ease-in-out',
    swipe: false,
    swipeToSlide: false,
    touchMove: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    draggable: false
});

// $( ".slick-dots" ).append( "<div><a target='_blank' href='https://www.artsy.net/sugarlift/artists' class='btn hero__cta' style='margin-top: 35px'>Browse all Artists</a></div>" );

